import { gql } from '@apollo/client';
import { MEDIA_FIELD } from '../../fragments/fields/media';
import { ANIMATED_TEXT_BLOCK, ARTICLES_SCROLLER_BLOCK, COLUMNS_BLOCK, COMPARISONS_BLOCK, CONTENT_BLOCK, CTA_BUTTON_BLOCK, IMAGE_BLOCK, LEAD_FORM_BLOCK } from '../../fragments/blocks';
import { CTA_BLOCK } from '../../fragments/blocks/Cta';
import { FAQ_BLOCK } from '../../fragments/blocks/faq';
import { BACKGROUND_WITH_BLOCK } from '../../fragments/blocks/backgroundWithBlock';
import { SPACER_BLOCK } from '../../fragments/blocks/Spacer';
import { CARD_WITH_BLOCKS } from '../../fragments/blocks/card';
import { SLIDER_WITH_BLOCKS } from '../../fragments/blocks/sliderWithBlocks';
import { LISTS_BLOCK } from '../../fragments/blocks/lists';
import { FORM_BLOCK } from '../../fragments/blocks/form';
import { FORM_FIELD } from '../../fragments/fields/form';

export const SERVICE = gql`
  query Service($draft: Boolean, $where: Service_where) {
    Services(draft: $draft, where: $where, limit: 1, page: 1) {
      docs {
        id
        titleSettings {
          boldStartIndex
          boldEndIndex
        }
        title
        description
        header {
          type
          beforeFeaturedFormContent
          featuredForm {
            ...FormFieldFragment
          }
          image {
            ...MediaFieldFragment
          }
          showLookingForForm
          showRatingWidget
        }
        layout {
          blocks {
            ...AnimatedTextBlockFragment
            ...ArticlesScrollerBlockFragment
            ...BackgroundWithBlockFragment
            ...CardWithBlocksFragment
            ...ColumnsBlockFragment
            ...ContentBlockFragment
            ...CtaBlockFragment
            ...FaqBlockFragment
            ...FormBlockFragment
            ...ImageBlockFragment
            ...ListsBlockFragment
            ...SliderWithBlocksFragment
            ...SpacerBlockFragment
            ...VerticalSliderBlockFragment
            ...LeadFormBlockFragment
            ...CtaButtonBlockFragment
            ...ComparisonsBlockFragment
          }
        }
        meta {
          title
          description
          noIndex
          image {
            ...MediaFieldFragment
          }
        }
        slug
        updatedAt
        createdAt
        showGetAQuoteSideDrawer
      }
    }
  }
  ${ANIMATED_TEXT_BLOCK}
  ${ARTICLES_SCROLLER_BLOCK}
  ${BACKGROUND_WITH_BLOCK}
  ${CARD_WITH_BLOCKS}
  ${COLUMNS_BLOCK}
  ${CONTENT_BLOCK}
  ${CTA_BLOCK}
  ${FAQ_BLOCK}
  ${FORM_BLOCK}
  ${FORM_FIELD}
  ${IMAGE_BLOCK}
  ${LISTS_BLOCK}
  ${LISTS_BLOCK}
  ${MEDIA_FIELD}
  ${SLIDER_WITH_BLOCKS}
  ${SLIDER_WITH_BLOCKS}
  ${SPACER_BLOCK}
  ${LEAD_FORM_BLOCK}
  ${CTA_BUTTON_BLOCK}
  ${COMPARISONS_BLOCK}
`;

export const SERVICES = gql`
  query Services($where: Service_where, $limit: Int, $page: Int, $sort: String) {
    Services(where: $where, limit: $limit, page: $page, sort: $sort) {
      docs {
        id
        title
        description
        header {
          type
          image {
            ...MediaFieldFragment
          }
        }
        excerpt
        shortTitle
        featuredImage {
          ...MediaFieldFragment
        }
        slug
        updatedAt
        createdAt
      }
    }
  }
  ${MEDIA_FIELD}
`;
